import { X } from "lucide-react";
import { CATEGORIE_TICKET, STATUT_TICKET } from "../../config/statuses";
import type { TicketsFilters } from "../../hooks/useTicketsFilters";

const QUICK_FILTER_LABELS: Record<string, string> = {
  all: "Tous",
  open: "Ouverts",
  proposition_solution: "Propositions",
  bug: "Bugs",
};

interface TicketsActiveFiltersProps {
  filters: TicketsFilters;
}

/**
 * Active filter badges with individual remove buttons and "Tout effacer".
 * Only renders when at least one filter is active.
 */
export function TicketsActiveFilters({ filters }: TicketsActiveFiltersProps) {
  const hasStatus = Boolean(filters.selectedStatus);
  const hasCategory = Boolean(filters.selectedCategory);
  const hasQuickFilter = filters.activeQuickFilter !== "all";
  const hasSearch = Boolean(filters.searchQuery);
  const hasDevView = filters.isDevView;
  if (!hasStatus && !hasCategory && !hasQuickFilter && !hasSearch && !hasDevView) return null;

  return (
    <div className="flex flex-wrap gap-2 items-center">
      <span className="text-sm text-base-content/60">Filtres actifs:</span>
      {hasQuickFilter && (
        <span className="badge badge-primary gap-1">
          {QUICK_FILTER_LABELS[filters.activeQuickFilter] ?? filters.activeQuickFilter}
          <button
            type="button"
            onClick={() => filters.setActiveQuickFilter("all")}
            aria-label={`Retirer le filtre ${QUICK_FILTER_LABELS[filters.activeQuickFilter] ?? filters.activeQuickFilter}`}
          >
            <X className="w-3 h-3" />
          </button>
        </span>
      )}
      {hasStatus && (
        <span className="badge badge-outline gap-1">
          Statut:{" "}
          {STATUT_TICKET[filters.selectedStatus as keyof typeof STATUT_TICKET]?.label ??
            filters.selectedStatus}
          <button
            type="button"
            onClick={() => filters.setSelectedStatus("")}
            aria-label="Retirer le filtre statut"
          >
            <X className="w-3 h-3" />
          </button>
        </span>
      )}
      {hasCategory && (
        <span className="badge badge-outline gap-1">
          Catégorie:{" "}
          {CATEGORIE_TICKET[filters.selectedCategory as keyof typeof CATEGORIE_TICKET]?.label ??
            filters.selectedCategory}
          <button
            type="button"
            onClick={() => filters.setSelectedCategory("")}
            aria-label="Retirer le filtre catégorie"
          >
            <X className="w-3 h-3" />
          </button>
        </span>
      )}
      {hasSearch && (
        <span className="badge badge-secondary gap-1">
          Recherche: {filters.searchQuery}
          <button
            type="button"
            onClick={() => filters.setSearchQuery("")}
            aria-label="Retirer le filtre recherche"
          >
            <X className="w-3 h-3" />
          </button>
        </span>
      )}
      {hasDevView && (
        <span className="badge badge-accent gap-1">
          Vue développeur
          <button
            type="button"
            onClick={() => filters.setIsDevView(false)}
            aria-label="Retirer le filtre vue développeur"
          >
            <X className="w-3 h-3" />
          </button>
        </span>
      )}
      <button
        type="button"
        className="btn btn-ghost btn-xs text-error"
        onClick={filters.clearFilters}
      >
        Tout effacer
      </button>
    </div>
  );
}
